/* eslint-disable react/no-direct-mutation-state */
/* eslint-disable no-empty */
/* eslint-disable react/no-deprecated */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-case-declarations */
/* eslint-disable no-undef */
/* eslint-disable prettier/prettier */
import * as React from "react";
import { Client } from "@microsoft/microsoft-graph-client";
import { IConfiguration, IListField, ISearchTerms, LookUpData } from "./interfaces";
import { ActionButton, Checkbox, ComboBox, DatePicker, Dropdown, FontSizes, FontWeights, IComboBox, IComboBoxOption, IDropdownOption, IIconProps, ILabelStyleProps, ILabelStyles, IPanelStyles, ITextFieldStyleProps, ITextFieldStyles, Panel, PanelType, PrimaryButton, Spinner, SpinnerSize, TextField, Toggle, defaultDatePickerStrings, getTheme } from "@fluentui/react";
import Autocomplete from "./Autocomplete";

import { ISEntity } from "./IEntities";
import { configs } from "./Configs";
import { MailsFrom } from "./MailsFrom";
import { fontWeight } from "html2canvas/dist/types/css/property-descriptors/font-weight";
//import { PaddingLeft20Regular } from "@fluentui/react-icons";

const theme = getTheme();
const addFriendIcon: IIconProps = { iconName: 'AddFriend' };
const dropdownStyles = { dropdown: { width: '100%', } };
const buttonStyles = { root: { marginRight: 8 } };

interface IFPropertiesProps {
  fields: IListField[];
  siteID: string;
  client: Client;
  entities: ISEntity[];
  mailfrom: string;
  options: IDropdownOption[];
  list: string;
  path: string;
  locTitle: string;
  createMailFields: (c?: boolean) => void;
  isList: boolean;
}
interface IFPropertiesState {
  displaySpinner: boolean;
}

export class FProperties extends React.Component<IFPropertiesProps, IFPropertiesState> {
  private _tmpOptions: IDropdownOption[] = [];
  private _terms: ISearchTerms[] = [];
  // private _item: any;
  private eFields: IListField[] = [];
  private lookupData: LookUpData[] = [];
  private numberOfLookUp: number = 0;
  private Entityoptions: IComboBoxOption[] = [];
  protected outConfig: IConfiguration = { locations: [], recents: [] };
  constructor(props: IFPropertiesProps) {
    super(props);
    this.loadProprties = this.loadProprties.bind(this);

    //  console.log("FTProperties", this.props.fields);
    this.Ctl = this.Ctl.bind(this);
    this.state = { displaySpinner: true };
    this.numberOfLookUp = this.props.fields.filter((x) => x.LookupList != undefined && x.LookupList.length > 0).length;

    this.loadProprties();
    if (localStorage.getItem('outConfig') != null) {
      this.outConfig = JSON.parse(localStorage.getItem('outConfig'));
    }

    configs.WithEntities && this.props.entities.map((entity) =>
      this.Entityoptions.push({ key: entity.Id, text: entity.Header, selected: false }));
    //  this.changeState(n);
  }
  componentWillReceiveProps(nextProps: Readonly<IFPropertiesProps>, _nextContext: any): void {

    const nfields = nextProps.fields.filter((x) => x.LookupList != undefined && x.LookupList.length > 0).length;
    if (nfields <= 0) {

      this.setState({ displaySpinner: false });
    }

    nextProps.fields.filter((x) => x.LookupList != undefined && x.LookupList.length > 0)
      .map(async (item) => {
        const lookupdata: LookUpData = { lookupListID: item.LookupList, lookupFieldName: item.Title, lookupData: [] };
        this.props.client
          .api(`/sites/${nextProps.siteID}/lists/${item.LookupList}/items?$expand=fields($select=Id,Title,${item.LookupField})&$top=5000`)
          .get()
          .then((response) => {
            //  console.log("Item ->data", response.value);
            response.value.filter((z) => z.fields != undefined).map((o) => {
              lookupdata.lookupData.push({ id: o.fields.id, value: o.fields[item.LookupField] });
            });
            this.lookupData.push(lookupdata);
            if (this.numberOfLookUp == this.lookupData.length) {
              this.setState({ displaySpinner: false });
            }
          }).catch(error => {
            console.log('Error ', `/sites/${nextProps.siteID}/lists/${item.LookupList}/items?$expand=fields($select=Id,Title,${item.LookupField})&$top=5000`, ' ', error);
          });
      });
  }

  private loadProprties(): void {
    const nfields = this.props.fields.filter((x) => x.LookupList != undefined && x.LookupList.length > 0).length;
    if (nfields <= 0) {

      this.state = { displaySpinner: false };
    }

    this.props.fields.filter((x) => x.LookupList != undefined && x.LookupList.length > 0)
      .map(async (item) => {
        const lookupdata: LookUpData = { lookupListID: item.LookupList, lookupFieldName: item.Title, lookupData: [] };
        this.props.client
          .api(`/sites/${this.props.siteID}/lists/${item.LookupList}/items?$expand=fields($select=Id,Title,${item.LookupField})&$top=5000`)
          .get()
          .then((response) => {
            //  console.log("Item ->data", response.value);
            response.value.filter((z) => z.fields != undefined).map((o) => {
              // console.log("Inside-->", o);
              lookupdata.lookupData.push({ id: o.fields.id, value: o.fields[item.LookupField] });
            });
            this.lookupData.push(lookupdata);
            if (this.numberOfLookUp == this.lookupData.length) {
              this.setState({ displaySpinner: false });
            }
          }).catch(error => {
            console.log('Error', `/sites/${this.props.siteID}/lists/${item.LookupList}/items?$expand=fields($select=Id,Title,${item.LookupField})&$top=5000`, ' ', error);
          });
      });

    //this.setState({displaySpinner:false});
  }
  private loadProprtiesBPhase(SiteId: string, listID: string): void {
    let webName: string = '';
    listID
    this.props.client
      .api(`https://graph.microsoft.com/v1.0/sites/${SiteId}/lists/${listID}/columns?$expand=*`)
      .get()
      .then(response => {
        let Id: string;
        let InternalName: string;
        let LookupField: string;
        let LookupList: string;
        let LookupWebId: string;
        let PrimaryFieldId: string;
        let StaticName: string;
        let Title: string;
        let TypeAsString: string;
        let TypeDisplayName: string;
        let ListId: string;
        let CanBeDeleted: boolean;
        let allowMultipleSelection: boolean = false;
        let Choises: string[] = [];
        let MaximumValue: number;
        let MinimumValue: number;
        let TermGuidId: string;
        this.eFields = [];
        response.value.map((field: any) => {
          if (
            !field.name.startsWith("_") &&
            field.name !== "ParentVersionString" &&
            field.name !== "ParentLeafName" &&
            field.name !== "SampleModelId" &&
            field.name !== "AppAuthor" &&
            field.name !== "Created" &&
            field.name !== "Color Tag" &&
            field.name !== "Author" &&
            field.name !== "ComplianceAssetId" &&
            field.name !== "ContentType" &&
            field.name !== "Author" &&
            field.name !== "Modified" &&
            field.name !== "Editor" &&
            field.name !== "PrimeModelURL" &&
            field.name !== "PrimeModelVersion" &&
            field.name !== "MediaServiceImageTags" &&
            field.name !== "MediaServiceOCR" &&
            field.name !== "CheckoutUser" &&
            field.name !== "LinkFilenameNoMenu" &&
            field.name !== "LinkFilename" &&
            field.name !== "ItemChildCount" &&
            field.name !== "FolderChildCount" &&
            field.name !== "AppAuthor" &&
            field.name !== "AppEditor" &&
            field.name !== "Edit" &&
            field.name !== "ParentVersionString" &&
            field.name !== "ParentLeafName" &&
            field.name !== "AppEditor" &&
            field.name !== "ItemChildCount" &&
            field.name !== "CheckoutUser" &&
            field.name !== "LabelAppliedBy" &&
            field.name !== "RetentionLabelApplied" &&
            field.name !== "RetentionLabel" &&
            field.name !== "Check In Comment" &&
            field.name !== "Folder Child Count" &&
            field.name !== "FolderChildCount" &&
            field.name !== "ParentVersionString" &&
            field.name !== "ParentLeafName" &&
            field.name !== "Label setting" &&
            !field.name.startsWith("ModelUsage") &&
            field.name !== "Attachments" &&
            field.name !== "Editor" &&
            field.columnGroup !== "_Hidden") {
            Id = field.id;
            PrimaryFieldId = field.id;
            InternalName = field.name;
            StaticName = field.name;
            Title = field.displayName;
            CanBeDeleted = !field.readOnly;

            for (const prop in field) {
              switch (prop) {
                case "text":
                  TypeAsString = "Text";
                  TypeDisplayName = "Text";
                  break;
                case "dateTime":
                  TypeAsString = "DateTime";
                  TypeDisplayName = "DateTime";
                  break;
                case "boolean":
                  TypeAsString = "Boolean";
                  TypeDisplayName = "Boolean";
                  break;
                case "choice":
                  TypeAsString = "Choice";
                  TypeDisplayName = "Choice";
                  field.choice.choices.map((s: string) => Choises.push(s));
                  break;
                case "lookup":
                  TypeAsString = "Lookup";
                  TypeDisplayName = "Lookup";
                  LookupList = field.lookup.listId;
                  LookupField = field.lookup.columnName;
                  LookupWebId = SiteId;
                  break;
                case "personOrGroup":
                  TypeAsString = "UserMulti";
                  TypeDisplayName = "UserMulti";
                  allowMultipleSelection = field.personOrGroup.allowMultipleSelection;
                  break;
                case "number":
                  TypeAsString = "Number";
                  TypeDisplayName = "Number";
                  break;
                case "defaultValue":
                  const regex = /^(\d+);#[A-Z]+\|[\da-f-]+$/i;
                  if (regex.test(field.defaultValue.value)) {
                    TypeAsString = "TaxonomyFieldType";
                    TypeDisplayName = "TaxonomyFieldType";
                    TermGuidId = field.defaultValue.value.split('|')[1];
                  }
                  break;
                default:
                  TypeAsString = "Unknown";
                  TypeDisplayName = "Unknown";
                  break;
              }
            }
            this.eFields.push({
              Id: Id,
              InternalName: InternalName,
              LookupField: LookupField,
              LookupList: LookupList,
              LookupWebId: LookupWebId,
              PrimaryFieldId: PrimaryFieldId,
              StaticName: StaticName,
              Title: Title,
              TypeAsString: TypeAsString,
              TypeDisplayName: TypeDisplayName,
              ListId: ListId,
              CanBeDeleted: CanBeDeleted,
              Choises: Choises,
              MaximumValue: MaximumValue,
              MinimumValue: MinimumValue,
              allowMultipleSelection: allowMultipleSelection,
              TermGuidId: TermGuidId
            });
            Choises = [];
            LookupList = "";
          }
        });
        sessionStorage.setItem('eFields', JSON.stringify(this.eFields));

      })
      .catch(error => {
        console.log('Error', `https://graph.microsoft.com/v1.0/sites/${SiteId}/lists/${listID}/columns?$expand=*`, ' ', error);
      });
  }
  //@ts-ignore
  private Ctl = (o: IListField): JSX.Element => {
    switch (o.TypeAsString) {
      case "Boolean":
        // console.log("Boolean", this.props.item, " o.staticName", o.StaticName);
        return (
          <div className="ms-Grid-row" key={o.Id}>
            <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12" style={{ margin: 0, padding: 0 }}>
              <div
                style={{ textAlign: "left", fontSize: FontSizes.small, color: theme.palette.themePrimary, paddingTop: 5 }}
              >{`${o.Title}`}</div>
              <Toggle //label={o.Title}
                style={{ fontSize: "smaller", fontWeight: "normal!important" }}
                onChange={(_event: React.MouseEvent<HTMLElement>, checked?: boolean) => {
                  this._terms.push({ key: o.StaticName, value: checked as unknown as string });
                  sessionStorage.setItem(Office.context.mailbox.userProfile.emailAddress.toString() + "ChangedItems", JSON.stringify(this._terms));
                }}
              />
            </div>
          </div>
        );

      case "Choice":
        const options: IDropdownOption[] = [];
        o.Choises.map((x) => {
          options.push({ key: x, text: x });
        });
        return (
          <div className="ms-Grid-row" key={o.Id}>
            <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12" style={{ margin: 0, padding: 0 }}>
              <div
                style={{ textAlign: "left", fontSize: FontSizes.small, color: theme.palette.themePrimary, paddingTop: 5 }}
              >{`${o.Title}`}</div>
              <Dropdown
                placeholder={`${o.Title}`}
                // label={`${o.Title}`}
                // defaultSelectedKey={this._item[o.StaticName]}
                ariaLabel="Custom dropdown label example"
                styles={dropdownStyles}
                //   className={styles.header3}
                options={options}
                onChange={(_oo, ii) => {
                  const cs: ISearchTerms = this._terms.filter(
                    (xx) => xx.key.toUpperCase() === o.StaticName.toUpperCase()
                  )[0];
                  // @ts-ignore
                  cs !== undefined
                    ? (cs.value = ii.text.trim())
                    : this._terms.push({ key: o.StaticName, value: ii.text.trim() });
                  sessionStorage.setItem(Office.context.mailbox.userProfile.emailAddress.toString() + "ChangedItems", JSON.stringify(this._terms));
                }}
              />
            </div>
          </div>
        );
      //  break;
      case "DateTime":
        return (
          <div className="ms-Grid-row" key={o.Id}>
            <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12" style={{ margin: 0, padding: 0 }}>
              <div
                style={{ textAlign: "left", fontSize: FontSizes.small, color: theme.palette.themePrimary, paddingTop: 5 }}
              >{`${o.Title}`}</div>
              <DatePicker
                // @ts-ignore
                //  value={this._item[o.StaticName] !== null && new Date(this._item[o.StaticName].toString())}
                placeholder={`${o.Title}`}
                style={{ width: "100%" }}
                //   label={`${o.Title}`}
                //   className={styles.header3}
                ariaLabel="Select a date"
                strings={defaultDatePickerStrings}
                styles={{ textField: { width: "100%" } }}
                onSelectDate={(d) => {
                  const cs: ISearchTerms = this._terms.filter(
                    (xx) => xx.key.toUpperCase() === o.StaticName.toUpperCase()
                  )[0];
                  //@ts-ignore
                  cs !== undefined
                    ? (cs.value = d.toLocaleDateString())
                    : this._terms.push({ key: o.StaticName, value: d.toISOString() });
                  sessionStorage.setItem(Office.context.mailbox.userProfile.emailAddress.toString() + "ChangedItems", JSON.stringify(this._terms));
                }}
              />
            </div>
          </div>
        );
      //  break;
      case "Number":
        return (
          <div className="ms-Grid-row" key={o.Id}>
            <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12" style={{ margin: 0, padding: 0 }}>
              <div
                style={{ textAlign: "left", fontSize: FontSizes.small, color: theme.palette.themePrimary, paddingTop: 5 }}
              >{`${o.Title}`}</div>
              <TextField
                type="number"
                min={o.MinimumValue}
                max={o.MaximumValue}
                onChange={(e, n) => {
                  console.log(e);
                  const cs: ISearchTerms = this._terms.filter(
                    (xx) => xx.key.toUpperCase() === o.StaticName.toUpperCase()
                  )[0];
                  // @ts-ignore
                  cs !== undefined ? (cs.value = n) : this._terms.push({ key: o.StaticName, value: n });
                  sessionStorage.setItem(Office.context.mailbox.userProfile.emailAddress.toString() + "ChangedItems", JSON.stringify(this._terms));
                }}
                width="100%" //className={styles.header3}
              />
            </div>
          </div>
        );
      //  break;
      case "Note":
      case "Text":
        return (
          <div className="ms-Grid-row" key={o.Id}>
            <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12" style={{ margin: 0, padding: 0 }}>
              <TextField
                placeholder={`${o.Title}`}
                label={`${o.Title}`}
                styles={{
                  fieldGroup: { width: "1005" },
                  subComponentStyles: {
                    label: {
                      root: {
                        color: theme.palette.themePrimary,
                        fontSize: FontSizes.small,
                      },
                    },
                  },
                }}
                // defaultValue={this._item[o.StaticName]}
                onChange={(e, n) => {
                  console.log(e);
                  const cs: ISearchTerms = this._terms.filter(
                    (xx) => xx.key.toUpperCase() === o.StaticName.toUpperCase()
                  )[0];
                  // @ts-ignore
                  cs !== undefined ? (cs.value = n) : this._terms.push({ key: o.StaticName, value: n });
                  sessionStorage.setItem(Office.context.mailbox.userProfile.emailAddress.toString() + "ChangedItems", JSON.stringify(this._terms));
                }} //className={styles.header3}
              />
            </div>
          </div>
        );
      // break;
      case "Lookup":
        //  const id: number = this._item[o.StaticName + "Id"] as number;
        // const item = o.StaticName + (this.props.comesFrom === 2 ? "LookupId" : "Id");
        // const id = this._item[item];
        const coptions = this.lookupData.find((xx) => xx.lookupFieldName === o.Title).lookupData.map((o) => ({ key: o.id, text: o.value }));
        return (
          <div className="ms-Grid-row" key={o.Id}>
            <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12" style={{ margin: 0, padding: 0 }}>

              <ComboBox
                defaultSelectedKey={o.Id}
                label={o.Title}
                options={coptions}
                allowFreeInput
                autoComplete="on"
                onChange={(_event: React.FormEvent<IComboBox>, option: IComboBoxOption, _index?: number, _value?: string) => {
                  this._terms.push({ key: o.StaticName, value: option.key.toString() });
                  sessionStorage.setItem(Office.context.mailbox.userProfile.emailAddress.toString() + "ChangedItems", JSON.stringify(this._terms));
                }}

              />
              {/* <Autocomplete // initKey={id}
                //  initial={this.props.d.filter(xx => xx.name === o.Title)[0].data[0]}
                title={o.Title}
                //@ts-ignore
                onchange={(e: any, o1: any) => {
                  this._terms.push({ key: o.StaticName, value: o1.key });
                  sessionStorage.setItem(Office.context.mailbox.userProfile.emailAddress.toString() + "ChangedItems", JSON.stringify(this._terms));
                }}
                key2={o.Id}
                avData={this.lookupData.find((xx) => xx.lookupFieldName === o.Title).lookupData}
              /> */}
            </div>
          </div>
        );
      // break;
      case "Unknown":
        break;
    }
  };

  public render(): JSX.Element {

    return (
      <React.Fragment>
        <div className="ms-SPLegacyFabricBlock">
          <div className="ms-Grid" dir="ltr">
            {this.state.displaySpinner &&
              <Spinner label="Nope, still Loading..." ariaLive="assertive" labelPosition="left" size={SpinnerSize.large} />
            }
            {
              !this.state.displaySpinner &&
              <div className="ms-Grid-row">
                <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12" >


                  {/* <div style={{ margin: 0, padding: 0, textAlign: "right" }}>
                    <ActionButton iconProps={addFriendIcon} allowDisabledFocus disabled={false} checked={false} onClick={() => {
                      this.setState({ panelOpen: true });
                    }}>
                      All Emails from selected account.
                    </ActionButton>
                    </div> */}

                  <Checkbox styles={{ text: { fontSize: FontSizes.small, fontWeight: FontWeights.semibold, paddingBottom: 10 } }} label="Pin this location" onChange={() => {
                    let conf: IConfiguration = { locations: [], recents: [] };
                    if (localStorage.getItem('outConfig') != null) {
                      conf = JSON.parse(localStorage.getItem('outConfig'));
                      if (conf.locations.filter(x => x.path === this.props.path).length <= 0) {
                        conf.locations.push({ siteid: this.props.siteID, listid: this.props.list, path: this.props.path, title: this.props.locTitle, saved: new Date().toLocaleString('el-GR', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit', hour12: false, }) });
                        localStorage.setItem('outConfig', JSON.stringify(conf));
                      }
                    } else {
                      conf.locations.push({
                        siteid: this.props.siteID, listid: this.props.list, path: this.props.path, title: this.props.locTitle, saved: new Date().toLocaleString('el-GR', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit', hour12: false, })
                      });
                      localStorage.setItem('outConfig', JSON.stringify(conf));
                    }
                  }} defaultChecked={this.outConfig.locations.filter(x => x.path === this.props.path).length > 0} />

                  {this.props.isList &&
                    <Checkbox styles={{ text: { fontSize: FontSizes.small, fontWeight: FontWeights.semibold, paddingBottom: 10 } }} label="Auto create list fields Subject,Body,From"
                      onChange={(_ev?: React.FormEvent<HTMLElement | HTMLInputElement>, checked?: boolean) => this.props.createMailFields(checked)}
                    ></Checkbox>
                  }
                  <Dropdown
                    placeholder="Save Specific Attachments. Default(All)"
                    multiSelect
                    options={this.props.options}
                    styles={dropdownStyles}
                    onChange={(_event: React.FormEvent<HTMLDivElement>, option?: IDropdownOption, _index?: number) => {
                      option.selected && this._tmpOptions.filter(x => x.key === option.key).length <= 0 && this._tmpOptions.push(option);
                      if (option.selected === false && this._tmpOptions.filter(x => x.key === option.key).length >= 0) {
                        this._tmpOptions = this._tmpOptions.filter(x => x.key !== option.key);
                      }

                      window.sessionStorage.setItem(Office.context.mailbox.userProfile.emailAddress.toString() + "Attachments", JSON.stringify(this._tmpOptions));
                    }}
                  />

                  {configs.WithEntities &&
                    <div style={{ textAlign: "left", fontSize: FontSizes.small, color: theme.palette.themePrimary }}
                    >Include Entities <br />
                      <Dropdown
                        placeholder="Entities where the file will be included"
                        // label="Entities included"
                        onChange={(_event: React.FormEvent<HTMLDivElement>, option?: IDropdownOption, _index?: number) => {
                          this.Entityoptions.filter(x => x.key == option.key)[0].selected = option.selected;
                          console.log("Entity selected", this.Entityoptions);
                          sessionStorage.setItem(Office.context.mailbox.userProfile.emailAddress.toString() + 'selectedEntities', JSON.stringify(this.Entityoptions))
                        }}
                        multiSelect
                        options={this.Entityoptions}
                        styles={dropdownStyles}
                      />   </div>
                  }


                </div>
              </div>
            }
            {!this.state.displaySpinner && this.props.fields.map(this.Ctl)}
          </div>
        </div>
      </React.Fragment>
    );
  }
}


function getStyles(props: ITextFieldStyleProps): Partial<ITextFieldStyles> {
  const { required } = props;
  return {
    fieldGroup: [
      { width: "100%" },
      required && {
        borderTopColor: props.theme.semanticColors.errorText,
      },
    ],
    subComponentStyles: {
      label: getLabelStyles,
    },
  };
}

function getLabelStyles(props: ILabelStyleProps): ILabelStyles {
  const { required } = props;
  return {
    root: required && {
      color: props.theme.palette.themePrimary, fontSize: 13
    },
  };
}


// console.log("load FTProperties",this.props.fields);

//https://graph.microsoft.com/v1.0/sites/440debda-2842-415b-b18c-35413e988f38/lists/792f45f3-1449-468d-9a7c-110bc085a677/items?$expand=fields($select=Id,Title)


//https://graph.microsoft.com/v1.0/sites/440debda-2842-415b-b18c-35413e988f38/lists/792f45f3-1449-468d-9a7c-110bc085a677/items?$expand=fields($select=Id,Title)&$top=5000
